import React from 'react';
import { CheckCircle } from 'lucide-react';

const WhyChooseUs = () => {
  const reasons = [
    {
      id: 1,
      title: 'Holistic Approach',
      description: 'We treat the root cause of disease, not just the symptoms, using a combination of Varma & Siddha, Ayurveda, Yoga, and Naturopathy.'
    },
    {
      id: 2,
      title: 'Experienced Doctors',
      description: 'Our team consists of certified Yoga and Naturopathy, Siddha and Varma, Ayurvedic physicians with decades of experience in treating chronic conditions.'
    },
    {
      id: 3,
      title: 'Proven Results',
      description: 'Thousands of patients have experienced significant improvement in their health conditions after our treatments.'
    },
    {
      id: 4,
      title: 'No Side Effects',
      description: 'Our Natural treatments are gentle on the body and free from the side effects common in conventional medicine.'
    }
  ];

  return (
    <section className="py-16 md:py-24 bg-swastik-blue text-white">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-swastik-earth font-medium">Why Choose Us</span>
          <h2 className="text-3xl md:text-4xl font-bold font-serif mb-4">The Shri Varaham Swastik Yoga Advantage</h2>
          <div className="h-1 w-20 bg-swastik-earth mx-auto mb-8"></div>
          <p className="text-lg md:text-xl text-white/80">
            At Shri Varaham Swastik Yoga & Naturopathy Clinic, we offer more than just treatments - we provide a path to lasting wellness through ancient wisdom and modern science.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {reasons.map(reason => (
            <div key={reason.id} className="bg-white/10 backdrop-blur-sm rounded-lg p-6 hover:bg-white/20 transition-colors">
              <div className="flex items-start">
                <CheckCircle className="h-6 w-6 text-swastik-earth mr-4 flex-shrink-0 mt-1" />
                <div>
                  <h3 className="text-xl font-bold mb-2">{reason.title}</h3>
                  <p className="text-white/80">{reason.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <div className="inline-flex items-center bg-swastik-earth/20 backdrop-blur-sm rounded-lg p-4 md:p-6">
            <p className="text-lg md:text-xl font-medium mr-2">
              Ready to start your healing journey?
            </p>
            <a href="#contact" className="whitespace-nowrap bg-swastik-earth text-swastik-blue font-medium py-2 px-6 rounded-full hover:bg-swastik-lightEarth transition-colors">
              Contact Us Today
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
